/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { LeftSide, LoginContainer, RightSide } from '../Login/LoginStyle'
import { Box, Button, CircularProgress, InputLabel, Typography } from '@mui/material'
import CustomToast from '../../../components/Toast/CustomToast'
import { useNavigate } from 'react-router-dom'
import useMasterApi from '../../../services/useMasterApi'
import useToast from '../../../hooks/useToast'
import PATH from '../../../router/params'
import { ENDPOINT } from '../../../services/endPoints'

const CheckYourEmail = () => {
    const navigate = useNavigate();
    const {post, data, error, loading} = useMasterApi();
    const { toastMessage, toast, toastType, setToast, showToast } = useToast()
 
    useEffect(()=>{
      if(data){
        if(data.success){
          showToast("success", "Email Re-send Successfully")          
        }
        if(error){
          showToast("error", error.data.error)
        }
      }
    },[data, error])

    const handleResendEmail = () =>{
        post(ENDPOINT.RESET_EMAIL_LINK, {email_id: localStorage.getItem("email"), user_type: "1", "resend_email": "1" })
    }

  return (
    <LoginContainer>
    <RightSide>
      <Box sx={{ height:"100%", display:"flex", flexDirection: "column", width:"100%",  alignItems:"center", gap: "2rem"  }}>
      <Box component="img" src="/assets/images/logo.png" alt="Ministry of Health Logo" style={{ width: "125px", height: "96px" }}/>
      </Box>
    </RightSide>
      <LeftSide>
        <Box sx={{ height:"100%", width: "100%", position:"relative" }}>
            <Box sx={{ display:"flex", flexDirection: "column", gap: "1rem", maxWidth:"550px", mx:"auto" }}>
               <Box sx={{textAlign:"center"}}>
                   <Typography variant="h1" fontWeight="bold" color={(theme)=>theme.palette.secondary.main}>
                        Check Your <Box sx={{display: "inline", color: (theme)=>theme.palette.aqua.main}}>Email!</Box>
                   </Typography>
            </Box> 
                <Typography variant="body1"  sx={{textAlign:"left",
                         }}>
                     We just emailed you a link to reset your password.
                     </Typography>
                     <Typography variant="body1"  sx={{textAlign:"left",
                         }}>
                     If you can't find the email, please check your spam folder.
                     </Typography>
                     <Typography variant="body1"  sx={{textAlign:"left",
                         }}>
                     See you soon!
                     </Typography>
                     <Typography variant="body1"  sx={{textAlign:"left",
                         }}>
                     If you have not received the email, please click on the button below to resend the email.
                     </Typography>
                     <Typography variant="body1"  sx={{textAlign:"left", fontWeight: "bold"
                         }}>
                     You can close this tab now.
                     </Typography>
                <Button type="button" disabled={loading} onClick={handleResendEmail} variant="contained" fullWidth sx={{mt:2}}> {loading ? <CircularProgress/> : "Re-Send"}</Button>
             </Box>
        </Box>
      </LeftSide>
      {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </LoginContainer>
  )
}

export default CheckYourEmail